// TODO: return correct tab based on location
export function getDefaultSearchTab() {
  return 'products';
}